import {
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_200,
} from '@oneaudi/unified-web-common';
import { ButtonGroup, TextButton, Text, TextLink } from '@oneaudi/unified-web-components';
import styled from 'styled-components';

export const StyledSubPageNavigation = styled.div<{
  isSticky: boolean;
}>`
  --boxShadow: 0 5px 4px -4px rgba(0, 0, 0, 0.16);
  position: ${(props) => (props.isSticky ? 'sticky' : '')};
  top: ${(props) => (props.isSticky ? '0' : '')};

  box-shadow: var(--boxShadow);
  z-index: 99;
`;

/** **
 * MAINMENU
 *** */
export const StyledMainMenu = styled.nav`
  position: relative;
  padding-block: ${process.env.IS_LEGACY
    ? 'var(--spacing-relative-md)'
    : 'var(--spacing-relative-sm)'};
  padding-inline: var(--page-margin);
  background: ${({ theme }) => theme.colors.mainMenu};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding-block: ${process.env.IS_LEGACY
      ? 'var(--spacing-relative-lg)'
      : 'var(--spacing-relative-sm)'};
  }
`;

export const LeftContainer = styled.div`
  width: 100%;
  flex-shrink: 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: auto;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const SubmenuTriggerWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: 58px;
    width: auto;
    display: flex;
    align-items: center;
    margin-inline-end: 28px;
  }
`;
export const MenuTriggerSectionWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: 58px;
    width: auto;
    display: flex;
    align-items: center;
    margin-inline-end: 28px;
  }
`;
export const HeadlineWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    visibility: visible;
  }
`;

export const SubmenuTriggerButton = styled.button`
  text-align: left;
  border: none;
  background-color: transparent;
  font-family: inherit;
  padding: 0;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    align-items: normal;
  }
`;

export const ToggleButton = styled.button`
  text-align: left;
  border: none;
  background-color: transparent;
  font-family: inherit;
  padding: 0;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    align-items: normal;
  }
`;

export const CtaWrapper = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: flex;
  }
`;

/** **
 * SUBMENU - Desktop
 *** */
export const DesktopMenuContainer = styled.div<{
  isSticky: boolean;
}>`
  transition: ${({ theme }) => theme.animations.transition};
  transition-property: height;
  position: relative;
  margin: 0;
  z-index: 98;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg - 1}px) {
    display: none;
  }
`;

export const DesktopMenuWrapper = styled.div<{
  withCTA: boolean;
}>`
  width: 100%;
  height: var(--height, 0);
  overflow-y: auto;
  padding: 0;
  position: absolute;
  top: 0;
  z-index: 99;
  box-sizing: border-box;
  visibility: hidden;
  transition: ${({ theme }) => theme.animations.transition};
  transition-property: height, visibility;
  background-color: ${({ theme }) => theme.colors.secondLevelMenu};
  box-shadow: var(--boxShadow);

  &.show {
    visibility: visible;
  }
  .subpage-navigation-bar {
    margin-block: ${SYS_SPACE_FIXED_100};
  }
  padding-inline: calc(var(--page-margin) - ${SYS_SPACE_FIXED_200});
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  > div {
    width: 100%;
  }
  align-items: center;
`;

export const StyledParagraph = styled(Text)`
  color: ${({ theme }) => theme.colors.headline};
`;

export const StyledSubheadline = styled(Text)`
  color: ${({ theme }) => theme.colors.subheadline};
  display: block;
`;

export const SecondLevelMenu = styled.div<{
  isSticky: boolean;
}>`
  transition: ${({ theme }) => theme.animations.transition};
  background-color: ${({ theme }) => (process.env.IS_LEGACY ? '' : theme.colors.secondLevelMenu)}};
  transition-property: height;
  position: relative;
  margin: 0;
  z-index: 98;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg - 1}px) {
    display: none;
  }
`;
/** **
 * SUBMENU - Mobile menu
 *** */
export const MobileMenuContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const MobileMenuWrapper = styled.nav`
  height: var(--height, 0);
  transition: ${({ theme }) => theme.animations.transition};
  transition-property: height, visibility;
  visibility: hidden;
  overflow: hidden;
  z-index: 99;
  &.show {
    visibility: visible;
    overflow: auto;
  }
  background-color: ${({ theme }) => theme.colors.secondLevelMenu};
  box-shadow: var(--boxShadow);
  position: relative;
  z-index: 98;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const LinkList = styled.ul`
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
  top: 100%;
  z-index: 99;
  width: 100vw;
  box-sizing: border-box;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const LinkListItem = styled.li`
  padding-block: var(--spacing-relative-sm);
  margin-inline: var(--page-margin);

  &:first-child {
    margin-block-start: var(--spacing-relative-sm);
  }
  &:last-child {
    margin-block-end: ${SYS_SPACE_FIXED_150};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    &:last-child {
      margin-block-end: var(--spacing-relative-md);
    }
  }
`;

export const LinkListLink = styled(TextLink)`
  text-decoration: none;
`;

export const UnderlinedText = styled(Text)`
  border-bottom: 2px solid;
  border-bottom-color: ${({ theme }) => theme.colors.underline};
  padding-bottom: 4px;
  display: inline-block;
  margin-block-end: -6px;
`;

export const MobileMenuButtonWrapper = styled.div`
  .divider {
    background: ${({ theme }) => theme.colors.divider};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;

export const MobileMenuButtonContainer = styled.div`
  max-width: 100%;
  display: grid;
  gap: 8px;
  padding: 0;
  margin-block: var(--spacing-relative-xl);
  margin-inline: var(--page-margin);
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;

/** **
 * STICKY BUTTONS
 *** */
export const StyledStickyButtons = styled.div`
  background: ${({ theme }) => theme.colors.stickyButtonsBg};
  position: absolute;
  width: 100%;
  z-index: 98;
  padding-inline: var(--page-margin);
  box-sizing: border-box;
  height: var(--height, 0);
  transition: ${({ theme }) => theme.animations.transition};
  transition-property: height, visibility;
  overflow: hidden;
  box-shadow: var(--boxShadow);
`;

export const StickyButtonsContainer = styled.div`
  margin: 0 0 16px 0;
  display: grid;
  gap: ${SYS_SPACE_FIXED_100};
`;

/** **
 * VtpContainer
 *** */
export const VtpContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SYS_SPACE_FIXED_100};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    gap: 16px;
  }
`;

export const MobileMenuButton = styled(TextButton)`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
    white-space: nowrap;
  }
`;

export const StyledTextButton = styled(TextButton)<{ isActive?: boolean }>`
  white-space: nowrap;
`;
